import { Tokens } from "@accurx/design";

export const CONVERSATION_GROUP_LIST_SPACING = 0.25;

export const CONVERSATION_GROUP_BREAKPOINT = Tokens.BREAKPOINTS.xl;
